import { useEffect, useState } from "react";
import { clearSession } from "../shared/_helpers/session";
import Modal from "react-bootstrap/Modal";
import { Link, useNavigate } from "react-router-dom";
import { getNotifications, removeNotification } from "../shared/_services/common.services";
import moment from 'moment';
import { useSnackbar } from "notistack";

const Notifications = ({ onClose, showModal }) => {
  const [notification, setNotification] = useState([]);
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const handleClose = () => {
    onClose(false);
  }

  const getNotificationData = async () => {
    const currentUser = JSON.parse(localStorage.getItem("currentUser"));
    const userId = currentUser?.user?._id
    const data = await getNotifications(userId);
    if (data.status === 200) {
      setNotification([...data?.data?.data]);
    }
    else {
      if (data?.response?.status === 401) {
        clearSession();
        enqueueSnackbar("Your session has been expired!", {
          variant: 'error',
          anchorOrigin: { horizontal: 'right', vertical: 'top' },
        });
        navigate('/login');
      }
    }
  }

  useEffect(() => {
    getNotificationData();
  }, []);

  const handleNavigate = async (type,data) => {
    if (type === "Appointment Reschedule Request") {
      navigate('/meetings');
    }
    if (type === "New Client Registration") {
      navigate('/users');
    }
    if(data){
      await removeNotification(data?._id,data?.type,data?.userId?._id);
      getNotificationData();
    }
    handleClose();
  }

  
  return (
    <Modal
      className="notificationPopup fade-right"
      show={showModal}
      onHide={handleClose}
      aria-labelledby="notificationPopupLabel"
      keyboard={false}
      centered
    >
      <div className="modal-body">
        <div className="d-flex mb-2 justify-content-between">
          <h4 className="ast-card-heading w-100 mb-2">Notifications</h4>
          <Link
            className="close-popup-btn"
            onClick={handleClose}
          >
            <i className="iconoir-xmark"></i>
          </Link>
        </div>

        <div className="notifications-body">
          {notification.length > 0 ? (
            notification.map((data, index) => {
              const currentDate = moment(data?.createdAt).format('YYYY-MM-DD');
              const previousDate = index > 0 ? moment(notification[index - 1]?.createdAt).format('YYYY-MM-DD') : null;

              return (
                <div
                  onClick={() => handleNavigate(data?.type, data)}
                  key={data._id}
                  role="button"
                  tabIndex="0"
                  onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleNavigate(data?.type, data); } }}
                  {...((data?.type === "Appointment Reschedule Request" || data?.type === "New Client Registration") && {
                    title: `Click to navigate to ${data?.type === "Appointment Reschedule Request" ? "meetings" : "client registration"} page`
                  })}
                  style={{
                    cursor: (data?.type === "Appointment Reschedule Request" || data?.type === "New Client Registration")
                      ? "pointer"
                      : "default"
                  }}
                >

                  {currentDate !== previousDate && (
                    <p className="f-500 mt-3 mb-2">{moment(data?.createdAt).format('dddd MMM Do YYYY')}</p>
                  )}
                  <div className="notification-box">
                    <p className="text-14 f-500">
                      {data?.description}
                    </p>
                    <p className="f-300 text-right text-12">{moment(data?.createdAt).format('LT')}</p>
                  </div>
                </div>
              );
            })
          ) : (
            <h2>No Data Found</h2>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default Notifications;
